import { isValidPhoneNumber } from "libphonenumber-js";
import { getCountryName } from "../utils/countryNamesPtBR";

export function toStoredPhoneDigits(raw) {
  return String(raw || "").replace(/\D/g, "");
}

/**
 * Valida WhatsApp/contato em E.164.
 * Aceita internacional com DDI e local BR (10–11) sem prefixo.
 */
export function isValidContactPhone(raw) {
  if (!raw || !String(raw).trim()) return false;
  const digits = toStoredPhoneDigits(raw);
  if (digits.length < 8 || digits.length > 15) return false;

  const trimmed = String(raw).trim();
  const withPlus = trimmed.startsWith("+") ? trimmed : `+${digits}`;

  try {
    if (isValidPhoneNumber(withPlus)) return true;
    if (digits.length === 10 || digits.length === 11) {
      return isValidPhoneNumber(digits, "BR");
    }
    return false;
  } catch {
    return false;
  }
}

export function filterCountries(countries, search) {
  const raw = String(search || "").trim().toLowerCase();
  const q = raw.replace(/^\+/, "");
  if (!q) return countries;

  return countries.filter((country) => {
    const name = getCountryName(country.iso2).toLowerCase();
    return (
      name.includes(q) ||
      country.iso2.toLowerCase().includes(q) ||
      country.dialCode.includes(q) ||
      raw === `+${country.dialCode}`
    );
  });
}
